import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '../../../../../theme';
import { getIsOpenedLastExchange } from '../../../../../Checkout/store/order/selectors';
import { getLastSelectedFlight } from '@entities/exchange';
import { useExchangeRouteControls } from '@features/exchange/exchange-route-controls';
import { useRefreshExchangeOrder } from '../../lib/useRefreshExchangeOrder';
import { ExchangeTicket } from '../ExchangeTicket';
import { ExchangeRequest } from '../ExchangeRequest';
const Request = () => {
    const { Request: theme } = useTheme('Widgets').Exchange;
    const isOpenedLastExchange = useSelector(getIsOpenedLastExchange);
    const lastSelectedFlight = useSelector(getLastSelectedFlight);
    const exchangeRouteControls = useExchangeRouteControls();
    const refreshExchangeOrder = useRefreshExchangeOrder();
    const isNewRequest = lastSelectedFlight && !isOpenedLastExchange;
    return (React.createElement("div", { className: theme.root }, isNewRequest ? (React.createElement(ExchangeRequest, { returnToOrder: exchangeRouteControls.onBackToOrder, reloadOrder: refreshExchangeOrder.onRefreshOrder })) : (React.createElement(ExchangeTicket, null))));
};
export default Request;
